import React, { useLayoutEffect } from 'react';

import { useEditorRef } from 'platejs/react';
import { Apollo } from 'src/gql/generated';

import { BaseSkillElementPlugin } from './AlineMarkdownEditor/plugins/skill-element-plugin';

export const SHARED_CHAT_SKILL_SCOPES = [
  Apollo.AgentSkillScope.Org,
  Apollo.AgentSkillScope.Community,
];

/** Update the picker in place when the active context or persisted thread audience changes. */
export const ChatSkillAudience = React.memo(function ChatSkillAudience({
  threadId,
  visibleContext,
}: {
  threadId: string | null;
  visibleContext?: Apollo.AgentVisibleContextInput;
}) {
  const editor = useEditorRef();
  const hasActiveContext = Boolean(visibleContext?.workflowId || visibleContext?.taskId);
  const { data } = Apollo.useGetAgentThreadSkillAudienceQuery({
    skip: !threadId || hasActiveContext,
    variables: { id: threadId ?? '' },
  });
  // An existing thread stays shared-only until its own audience has loaded.
  const sharedOnly =
    hasActiveContext ||
    Boolean(threadId && (data?.agentThread.id !== threadId || data.agentThread.usesSharedSkills));

  useLayoutEffect(() => {
    editor.setOption(
      BaseSkillElementPlugin,
      'offeredScopes',
      sharedOnly ? SHARED_CHAT_SKILL_SCOPES : null
    );
  }, [editor, sharedOnly]);

  return null;
});
